import React, { Fragment, useState } from 'react';
import { useTranslator } from 'tradera-lang';

const MAX_DROPDOWN_SIZE = 10;

const ItemQuantitySelector = ({
    quantity,
    quantityInShop,
    onQuantityChange
}) => {
    const { t } = useTranslator();
    const [inputMode, setInputMode] = useState(quantity > MAX_DROPDOWN_SIZE);

    const onChange = event => {
        const value = parseInt(event.target.value);
        if (isNaN(value)) return;

        if (value !== -1) {
            event.target.value = Math.min(value, quantityInShop);
            onQuantityChange(event);
        }

        if (value === -1) {
            setInputMode(true);
        }
    };

    return (
        <div className="form-group mr-4 mr-md-5 mb-0 flex-shrink-0">
            {!inputMode && (
                <select
                    defaultValue={quantity}
                    className={`form-control single-select pr-4 ${
                        quantity > quantityInShop ? 'border-danger' : ''
                    }`}
                    onChange={onChange}>
                    <option value={0}>Ta bort</option>
                    {[
                        ...Array(Math.min(quantityInShop, MAX_DROPDOWN_SIZE))
                    ].map((_, i) => {
                        const count = i + 1;
                        return (
                            <option className="px-3" key={count} value={count}>
                                {count} st
                            </option>
                        );
                    })}
                    {quantity > quantityInShop && (
                        <option className="px-3" value={quantity}>
                            {quantity} st
                        </option>
                    )}
                    {quantityInShop > MAX_DROPDOWN_SIZE && (
                        <option className="px-3" value={-1}>
                            {t('cartCheckoutOverview_numberOfPiecesOther')}
                        </option>
                    )}
                </select>
            )}
            {inputMode && (
                <input
                    type="number"
                    inputMode="numeric"
                    autoComplete="off"
                    min={0}
                    max={quantityInShop}
                    onChange={onChange}
                    className="form-control bg-white border"
                    defaultValue={quantity}
                />
            )}
        </div>
    );
};

const ItemDisplay = ({
    itemImage,
    itemTitle,
    formattedPrice,
    isFirstItem,
    quantity,
    quantityInShop,
    onQuantityChange,
    itemUrl
}) => {
    const { t } = useTranslator();

    return (
        <Fragment>
            <div className="row my-5 d-none d-md-block">
                <div className="col-12 d-flex align-items-center">
                    <div className="align-self-start mr-5 col-1">
                        {isFirstItem && (
                            <span className="h4 text-styled">
                                {t('checkout_item_title')}:
                            </span>
                        )}
                    </div>
                    <img className="mr-4" height="75px" src={itemImage} />
                    <a
                        href={itemUrl}
                        className="text-wrap flex-grow-1 mr-4 text-primary">
                        {itemTitle}
                    </a>

                    {quantityInShop !== undefined &&
                        quantity > quantityInShop && (
                            <div className="text-danger">
                                {t('checkout_item_outOfStock')}
                            </div>
                        )}

                    {quantityInShop !== undefined && (
                        <ItemQuantitySelector
                            quantity={quantity}
                            quantityInShop={quantityInShop}
                            onQuantityChange={onQuantityChange}
                        />
                    )}

                    <div className="text-right text-nowrap font-weight-bold">
                        {formattedPrice}
                    </div>
                </div>
            </div>
            {isFirstItem && (
                <div className="row d-block d-md-none my-4">
                    <div className="col-12 mr-4">
                        <span className="h4 text-styled">
                            {t('checkout_item_title')}:
                        </span>
                    </div>
                </div>
            )}
            <div className="row my-4 d-block d-md-none">
                <div className="col-12 d-flex">
                    <img className="mr-3" height="75px" src={itemImage} />
                    <div className="flex-grow-1">
                        <a href={itemUrl} className="mb-2 text-primary">
                            {itemTitle}
                        </a>

                        <div className="d-flex justify-content-between align-items-center mt-2">
                            {quantityInShop !== undefined && (
                                <ItemQuantitySelector
                                    quantity={quantity}
                                    quantityInShop={quantityInShop}
                                    onQuantityChange={onQuantityChange}
                                />
                            )}

                            <div className="text-nowrap font-weight-bold">
                                {formattedPrice}
                            </div>
                        </div>
                    </div>

                    {quantityInShop !== undefined &&
                        quantity > quantityInShop && (
                            <div className="text-danger">
                                {t('checkout_item_outOfStock')}
                            </div>
                        )}
                </div>
            </div>
        </Fragment>
    );
};

export default ItemDisplay;
